<template>
  <v-dialog v-model="dialogLocal" max-width="450px" persistent>
    <v-card>
      <v-card-title class="headline-custom" style="font-size: 1.3rem !important">
        Agendamento de atualização dos dados do Relatório #{{ data.id }}
      </v-card-title>
      <v-card-text style="font-size: 15px !important">
        <v-row class="align-center justify-left">
          <v-select v-model="selectedCron" :items="cronOptions" label="Selecione a frequência" class="px-3"></v-select>
        </v-row>
        <v-row v-if="selectedCron === 'semana'" class="align-center justify-left">
          <v-select v-model="selectedDay" :items="daysOfWeek" label="Selecione o dia da semana" class="px-3"></v-select>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="dialogLocal = false">Fechar</v-btn>
        <v-btn color="green darken-1" @click="agendar">Agendar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';

  export default {
    components: {},
    mixins: [],

    props: {
      dialog: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        required: true
      }
    },

    emits: ['submitTriggered', 'update:dialog'],

    data: () => ({
      selectedCron: 'manual',
      selectedDay: 0,
      cronOptions: [
        { text: 'Manual', value: 'manual' },
        { text: '30 minutos', value: 'minuto_30' },
        { text: '1 hora', value: 'hora_1' },
        { text: '12 horas', value: 'hora_12' },
        { text: '1 dia', value: 'dia_1' },
        { text: '1 mês', value: 'mes_1' },
        { text: 'Semanalmente', value: 'semana' }
      ],
      daysOfWeek: [
        { text: 'Domingo', value: 0 },
        { text: 'Segunda-feira', value: 1 },
        { text: 'Terça-feira', value: 2 },
        { text: 'Quarta-feira', value: 3 },
        { text: 'Quinta-feira', value: 4 },
        { text: 'Sexta-feira', value: 5 },
        { text: 'Sábado', value: 6 }
      ]
    }),

    computed: {
      dialogLocal: {
        get() {
          return this.dialog;
        },
        set(newValue) {
          this.$emit('update:dialog', newValue);
        }
      }
    },

    mounted() {
      this.fetchCron();
    },

    methods: {
      agendar() {
        const cron = this.getCron();
        this.$emit('submitTriggered', { id: this.data.id, cron });
      },

      getCron() {
        return {
          rate: this.selectedCron,
          diaSemana: this.selectedCron === 'semana' ? this.selectedDay : null
        };
      },

      fetchCron() {
        RelatoriosService.getAgendamento(this.data.id)
          .then(({ data }) => {
            this.setCron(data);
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao obter dados de agendamento de relatório.', '', { position: 'topRight' });
          });
      },

      setCron(cronInfo) {
        this.selectedCron = cronInfo.rate;
        this.selectedDay = cronInfo.diaSemana;
      }
    }
  };
</script>